(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["plan-filter-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    // pf-card-v2: move the "How it works" block to sit between the pricing
    // card and the FAQ list on the right column.
    (function relocateHowItWorks() {
      const howItWorks = document.querySelector('.plan-filter__step-wrapper_how-it-works');
      const faq = document.querySelector('.plan-filter__faq');
      if (!howItWorks || !faq) return;
      if (howItWorks.nextElementSibling !== faq) {
        faq.parentElement.insertBefore(howItWorks, faq);
      }
    })();

    // pf-card-v2: open/close "View more features" modal
    document.querySelectorAll('[data-pf-card-v2-open]').forEach((opener) => {
      const modalId = opener.getAttribute('aria-controls');
      const modal = modalId ? document.getElementById(modalId) : null;
      if (!modal) return;

      // Portal the modal to document.body so it escapes any ancestor stacking context
      // (e.g. .plan-filter__product-container has position: sticky).
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      const openModal = () => {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        const closeBtn = modal.querySelector('.pf-card-v2__modal-close');
        if (closeBtn) closeBtn.focus();
      };
      const closeModal = () => {
        modal.hidden = true;
        document.body.style.overflow = '';
        opener.focus();
      };

      opener.addEventListener('click', openModal);
      modal.querySelectorAll('[data-pf-card-v2-close]').forEach((el) => {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    });

    // Read SVG strings from <template> elements rendered by Liquid
    const _iconTpl = (name) => {
      const tpl = document.querySelector(`.plan-filter__icon-tpl[data-icon="${name}"]`);
      return tpl ? tpl.innerHTML : '';
    };
    const SVG_ADD_TO_CART = _iconTpl('add-to-cart');
    const SVG_CHECKMARK = _iconTpl('checkmark');

    function calculateDiscountPercent(compareCents, priceCents) {
      if (
        !Number.isFinite(compareCents) ||
        !Number.isFinite(priceCents) ||
        compareCents <= 0 ||
        compareCents <= priceCents
      ) {
        return null;
      }
      return Math.round(((compareCents - priceCents) / compareCents) * 100);
    }

    async function syncAddToCartLimitState(cardContainer, { refreshCart = false } = {}) {
      if (!cardContainer) return;

      const form = cardContainer.querySelector('form[data-type="add-to-cart-form"]');
      const submitBtn = form?.querySelector('[type="submit"][name="add"]');
      const qtyInput = form?.querySelector('quantity-selector-component input[ref="quantityInput"]');
      const variantIdInput = form?.querySelector('input[name="id"]');
      if (!form || !submitBtn || !qtyInput || !variantIdInput) return;

      const maxFromData = Number.parseInt(qtyInput.dataset.max || '', 10);
      const maxFromAttribute = Number.parseInt(qtyInput.max || '', 10);
      const resolvedMax = Number.isFinite(maxFromData) ? maxFromData : maxFromAttribute;

      const simRadios = Array.from(cardContainer.querySelectorAll('.plan-filter__sim_type-input'));
      const hasSelectedSimType = simRadios.length === 0 || simRadios.some((radio) => radio.checked);
      const variantRadios = Array.from(cardContainer.querySelectorAll('.plan-filter__variant-input'));
      const hasSelectedVariant = variantRadios.length === 0 || variantRadios.some((radio) => radio.checked);

      let cartQuantity = Number.parseInt(qtyInput.getAttribute('data-cart-quantity') || '0', 10);
      if (refreshCart && variantIdInput.value) {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          const variantId = String(variantIdInput.value);
          const cartItem = Array.isArray(cart?.items)
            ? cart.items.find((item) => String(item?.variant_id) === variantId)
            : null;
          cartQuantity = Number.parseInt(String(cartItem?.quantity || 0), 10) || 0;
        } catch (error) {
          cartQuantity = Number.parseInt(qtyInput.getAttribute('data-cart-quantity') || '0', 10) || 0;
        }
      }

      qtyInput.setAttribute('data-cart-quantity', String(Math.max(0, cartQuantity)));
      const reachedLimit = Number.isFinite(resolvedMax) && cartQuantity >= resolvedMax;
      //const shouldDisable = reachedLimit || !hasSelectedSimType || !hasSelectedVariant;

      //submitBtn.disabled = shouldDisable;
      //submitBtn.classList.toggle('is-disabled', reachedLimit);
    }

    // Watch each submit button for data-added attribute changes and update text + icon accordingly
    function initAddedToCartObserver(article) {
      const submitBtn = article.querySelector('[type="submit"][name="add"]');
      if (!submitBtn) return;

      const textEl = submitBtn.querySelector('.add-to-cart-text__content span span');
      if (!textEl) return;

      const iconEl = submitBtn.querySelector('.add-to-cart-icon');
      const defaultText = textEl.textContent.trim() || 'Add to Cart';

      const observer = new MutationObserver(() => {
        const isAdded = submitBtn.dataset.added === 'true';
        textEl.textContent = isAdded ? 'Added to Cart' : defaultText;
        if (iconEl) iconEl.innerHTML = isAdded ? SVG_CHECKMARK : SVG_ADD_TO_CART;
      });

      observer.observe(submitBtn, { attributes: true, attributeFilter: ['data-added'] });
    }

    // Recalculate displayed price when quantity changes: price = unitPrice × qty
    function initQuantityPriceSync(article) {
      const cardContainer = article.closest('.plan-filter_product_info');
      const priceEls = Array.from(cardContainer?.querySelectorAll('.plan-filter__price[data-unit-price]') || []);
      const qtySelector = cardContainer?.querySelector('quantity-selector-component[data-plan-quantity-selector]');
      const compareEls = Array.from(
        cardContainer?.querySelectorAll('.plan-filter__price-note[data-compare-price]') || []
      );
      const discountEls = Array.from(cardContainer?.querySelectorAll('.plan-filter__discount-badge') || []);
      const maxMessageEl = qtySelector?.closest('.plan-filter_quantity-block')?.querySelector('.max-message');
      const maxMessageTextEl = maxMessageEl?.querySelector('span:not(.icon)');
      const formComponent = cardContainer?.querySelector('product-form-component');
      if (!priceEls.length || !qtySelector) return;

      function formatCents(cents) {
        const amount = cents / 100;
        const hasCents = cents % 100 !== 0;
        const formatted = Math.abs(amount).toLocaleString('en-US', {
          minimumFractionDigits: hasCents ? 2 : 0,
          maximumFractionDigits: 2,
        });
        return `${amount < 0 ? '-' : ''}$${formatted}`;
      }

      function updatePrice(qty) {
        priceEls.forEach((priceEl) => {
          const unitCents = parseInt(priceEl.dataset.unitPrice, 10);
          if (!unitCents || isNaN(unitCents)) return;
          priceEl.textContent = formatCents(unitCents * Math.max(1, qty || 1));
        });
      }

      function updateComparePrice(qty) {
        compareEls.forEach((compareEl) => {
          const unitCents = parseInt(compareEl.dataset.comparePrice, 10);
          if (!unitCents || isNaN(unitCents)) return;
          const finalComparedPrice = formatCents(unitCents * Math.max(1, qty || 1));
          compareEl.textContent = `${finalComparedPrice} retail price`;
        });
      }

      function updateDiscount() {
        if (!discountEls.length || !compareEls.length || !priceEls.length) return;
        const compareCents = parseInt(compareEls[0].dataset.comparePrice, 10);
        const priceCents = parseInt(priceEls[0].dataset.unitPrice, 10);
        const discountPercent = calculateDiscountPercent(compareCents, priceCents);
        if (!Number.isFinite(discountPercent)) {
          discountEls.forEach((discountEl) => {
            discountEl.hidden = true;
          });
          return;
        }
        discountEls.forEach((discountEl) => {
          discountEl.textContent = `SAVE ${discountPercent}%`;
          discountEl.hidden = false;
        });
      }

      function syncMaxMessage() {
        if (!maxMessageEl) return;
        const qtyInput = qtySelector.querySelector('input[ref="quantityInput"]');
        if (!qtyInput) return;

        const quantity = parseInt(qtyInput.value, 10);
        const maxFromData = parseInt(qtyInput.dataset.max || '', 10);
        const maxFromAttribute = parseInt(qtyInput.max || '', 10);
        const resolvedMax = Number.isFinite(maxFromData) ? maxFromData : maxFromAttribute;
        const reachedMax = Number.isFinite(resolvedMax) && Number.isFinite(quantity) && quantity >= resolvedMax;

        if (!reachedMax) {
          clearTimeout(maxMessageEl._hideTimer);
          maxMessageEl.classList.remove('is-visible');
          return;
        }

        const template = formComponent?.dataset.quantityErrorMax || '';
        if (template && maxMessageTextEl) {
          maxMessageTextEl.textContent = 'A maximum of 2 plans are allowed for this plan.';
        }
        maxMessageEl.classList.add('is-visible');
        clearTimeout(maxMessageEl._hideTimer);
        maxMessageEl._hideTimer = setTimeout(() => {
          maxMessageEl.classList.remove('is-visible');
        }, 4000);
      }

      // quantity-selector-component fires 'quantity-selector:update' (not native input/change)
      qtySelector.addEventListener('quantity-selector:update', (event) => {
        updatePrice(event.detail.quantity);
        updateComparePrice(event.detail.quantity);
        updateDiscount();
        syncMaxMessage();
        syncAddToCartLimitState(cardContainer);
      });

      // Expose so applyVariant / applySimVariant can trigger a recalculation after updating unitPrice
      article._updatePrice = () => {
        const qtyInput = qtySelector.querySelector('input[ref="quantityInput"]');
        const qty = parseInt(qtyInput?.value, 10) || 1;
        updatePrice(qty);
        updateComparePrice(qty);
        updateDiscount();
        syncMaxMessage();
        syncAddToCartLimitState(cardContainer);
      };

      const qtyInput = qtySelector.querySelector('input[ref="quantityInput"]');
      qtyInput?.addEventListener('input', () => {
        syncMaxMessage();
        syncAddToCartLimitState(cardContainer);
      });
      syncMaxMessage();
      syncAddToCartLimitState(cardContainer, { refreshCart: true });
    }

    // Update variant selection: sync form hidden input + price display
    function initVariantSelector(container) {
      const radios = Array.from(container.querySelectorAll('.plan-filter__variant-input'));
      if (!radios.length) return;

      function applyVariant(radio) {
        if (!radio.checked) return;

        const formId = radio.dataset.formId;
        const variantId = radio.dataset.variantId;
        const priceFormatted = radio.dataset.variantPrice;
        const comparePriceFormatted = radio.dataset.variantComparePrice;
        const hasCompare = radio.dataset.variantHasCompare === 'true';
        const priceRawCents = parseInt(radio.dataset.variantPriceRaw, 10);

        if (formId) {
          const form = document.getElementById(formId);
          if (form) {
            const hiddenInput =
              form.querySelector('[ref="variantId"]') || form.querySelector('input[type="hidden"][name="id"]');
            if (hiddenInput) hiddenInput.value = variantId;
          }
        }

        const cardContainer = container.closest('.plan-filter_product_info');
        if (cardContainer) {
          const article = cardContainer.querySelector('article.plan-filter__product-card');
          const priceEl = cardContainer.querySelector('.plan-filter__price');
          if (priceEl) {
            if (priceRawCents > 0) priceEl.dataset.unitPrice = String(priceRawCents);
            if (typeof article._updatePrice === 'function') {
              article._updatePrice();
            } else if (priceFormatted) {
              priceEl.textContent = priceFormatted;
            }
          }

          const compareEl = cardContainer.querySelector('.plan-filter__price-note');
          const discountEl = cardContainer.querySelector('.plan-filter__discount-badge');
          if (compareEl) {
            if (hasCompare && comparePriceFormatted) {
              const compareRawCents = parseInt(radio.dataset.variantComparePriceRaw, 10);
              if (compareRawCents > 0) compareEl.dataset.comparePrice = String(compareRawCents);
              compareEl.textContent = `${comparePriceFormatted} retail price`;
              compareEl.hidden = false;
              if (discountEl) {
                const discountPercent = calculateDiscountPercent(compareRawCents, priceRawCents);
                if (Number.isFinite(discountPercent)) {
                  discountEl.textContent = `SAVE ${discountPercent}%`;
                  discountEl.hidden = false;
                } else {
                  discountEl.hidden = true;
                }
              }
            } else {
              compareEl.removeAttribute('data-compare-price');
              compareEl.hidden = true;
              if (discountEl) discountEl.hidden = true;
            }
          }

          syncAddToCartLimitState(cardContainer, { refreshCart: true });
        }

        radios.forEach((r) => {
          r.closest('[data-variant-option]')?.classList.toggle('is-selected', r === radio);
        });
      }

      radios.forEach((radio) => radio.addEventListener('change', () => applyVariant(radio)));

      const preselected = radios.find((r) => r.checked);
      if (preselected) applyVariant(preselected);
    }

    function showSimTypeError(container) {
      const el = container.querySelector('[data-sim-type-error]');
      if (!el) return;

      const simTypeSelected = container.querySelector('.plan-filter__sim_type-input:checked');
      if (simTypeSelected) {
        return;
      }

      el.classList.add('is-visible');
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      clearTimeout(el._simErrorTimer);
      // el._simErrorTimer = setTimeout(() => el.classList.remove('is-visible'), 3000);
    }

    function hideSimTypeError(container) {
      const el = container.querySelector('[data-sim-type-error]');
      if (!el) return;
      clearTimeout(el._simErrorTimer);
      el.classList.remove('is-visible');
    }

    // SIM type toggle: map SIM card selection to product variant + show/hide extra info blocks
    function initSimToggle(container) {
      const radios = Array.from(container.querySelectorAll('.plan-filter__sim_type-input'));
      if (!radios.length) return;

      const esimBlock = container.querySelector('.plan-filter__details-esim-extra-info');
      const physicalBlock = container.querySelector('.plan-filter__details-physical-sim-extra-info');

      function getSubmitButton(formId) {
        if (!formId) return null;
        const form = document.getElementById(formId);
        return form ? form.querySelector('[type="submit"][name="add"]') : null;
      }

      function applySimVariant(radio) {
        const variantId = radio.dataset.variantId;
        const priceFormatted = radio.dataset.variantPrice;
        const comparePriceFormatted = radio.dataset.variantComparePrice;
        const hasCompare = radio.dataset.variantHasCompare === 'true';
        const formId = radio.dataset.formId;
        const priceRawCents = parseInt(radio.dataset.variantPriceRaw, 10);

        // Enable button regardless of whether variant data is complete
        const submitBtn = getSubmitButton(formId);
        if (submitBtn) submitBtn.disabled = false;

        if (!formId || !variantId) return;

        const form = document.getElementById(formId);
        if (!form) return;

        const hiddenInput =
          form.querySelector('[ref="variantId"]') || form.querySelector('input[type="hidden"][name="id"]');
        if (hiddenInput) hiddenInput.value = variantId;

        //setVariantInUrl(variantId);

        const cardContainer = form.closest('.plan-filter_product_info');
        if (!cardContainer) return;
        const article = cardContainer.querySelector('article.plan-filter__product-card');

        const priceEl = cardContainer.querySelector('.plan-filter__price');
        if (priceEl) {
          if (priceRawCents > 0) priceEl.dataset.unitPrice = String(priceRawCents);
          if (typeof article._updatePrice === 'function') {
            article._updatePrice();
          } else if (priceFormatted) {
            priceEl.textContent = priceFormatted;
          }
        }

        const compareEl = cardContainer.querySelector('.plan-filter__price-note');
        const discountEl = cardContainer.querySelector('.plan-filter__discount-badge');
        if (compareEl) {
          if (hasCompare && comparePriceFormatted) {
            const compareRawCents = parseInt(radio.dataset.variantComparePriceRaw, 10);
            if (compareRawCents > 0) compareEl.dataset.comparePrice = String(compareRawCents);
            compareEl.textContent = `${comparePriceFormatted} retail price`;
            compareEl.hidden = false;
            if (discountEl) {
              const discountPercent = calculateDiscountPercent(compareRawCents, priceRawCents);
              if (Number.isFinite(discountPercent)) {
                discountEl.textContent = `SAVE ${discountPercent}%`;
                discountEl.hidden = false;
              } else {
                discountEl.hidden = true;
              }
            }
          } else {
            compareEl.removeAttribute('data-compare-price');
            compareEl.hidden = true;
            if (discountEl) discountEl.hidden = true;
          }
        }

        syncAddToCartLimitState(cardContainer, { refreshCart: true });
      }

      function updateVisibility() {
        const selected = radios.find((r) => r.checked);

        if (esimBlock) esimBlock.hidden = true;
        if (physicalBlock) physicalBlock.hidden = true;

        radios.forEach((r) => {
          r.closest('.plan-filter__sim_type-wrapper')?.classList.toggle('is-selected', r.checked);
        });

        if (!selected) {
          const anyFormId = radios.find((r) => r.dataset.formId)?.dataset.formId;
          const submitBtn = getSubmitButton(anyFormId);
          if (submitBtn) submitBtn.disabled = true;
          return;
        }

        hideSimTypeError(container);

        const isEsim = selected.dataset.simGroup === 'esim';
        if (isEsim && esimBlock) esimBlock.hidden = false;
        if (!isEsim && physicalBlock) physicalBlock.hidden = false;

        applySimVariant(selected);
      }

      radios.forEach((radio) => radio.addEventListener('change', updateVisibility));

      // Allow user to unselect a SIM type by clicking the same option again
      let lastChecked = null;
      radios.forEach((radio) => {
        radio.addEventListener('click', () => {
          if (radio === lastChecked) {
            radio.checked = false;
            lastChecked = null;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            lastChecked = radio;
          }
        });
      });

      // Ensure no SIM type pre-selected; extra info blocks and button start disabled
      radios.forEach((r) => {
        r.checked = false;
      });
      if (esimBlock) esimBlock.hidden = true;
      if (physicalBlock) physicalBlock.hidden = true;
      const initFormId = radios.find((r) => r.dataset.formId)?.dataset.formId;
      const initSubmitBtn = getSubmitButton(initFormId);
      if (initSubmitBtn) initSubmitBtn.disabled = true;

      // Detect clicks on the add-to-cart-component wrapper while button is disabled
      if (initFormId) {
        const initForm = document.getElementById(initFormId);
        const addToCartComp = initForm?.closest('product-form-component')?.querySelector('add-to-cart-component');
        initForm?.addEventListener(
          'submit',
          (event) => {
            const hasSelectedSimType = radios.some((r) => r.checked);
            if (hasSelectedSimType) return;
            event.preventDefault();
            event.stopPropagation();
            showSimTypeError(container);
          },
          true
        );
        if (addToCartComp) {
          addToCartComp.addEventListener('click', () => {
            const btn = getSubmitButton(initFormId);
            if (btn?.disabled) showSimTypeError(container);
          });
        }
      }
    }

    // Show trip context from plan-filter URL params in the product card subtitle
    function initTripContext() {
      const params = new URLSearchParams(window.location.search);
      const startRaw = params.get('plan_filter_start');
      const endRaw = params.get('plan_filter_end');
      const mode = params.get('plan_filter_mode');
      const usageRaw = params.get('plan_filter_usage');
      const recommendedDatesEl = document.querySelector('[data-plan-filter-recommended-dates]');
      const cardRoot = document.querySelector('.plan-filter_product_info');
      if (cardRoot) {
        const arrivalInput = cardRoot.querySelector('input[name="properties[_arrival_date]"]');
        const departureInput = cardRoot.querySelector('input[name="properties[_departure_date]"]');
        const usageInput = cardRoot.querySelector('input[name="properties[_data_usage]"]');

        if (arrivalInput) {
          if (startRaw) {
            arrivalInput.value = startRaw;
            arrivalInput.disabled = false;
          } else {
            arrivalInput.disabled = true;
          }
        }

        if (departureInput) {
          if (mode === 'round-trip' && endRaw) {
            departureInput.value = endRaw;
            departureInput.disabled = false;
          } else {
            departureInput.disabled = true;
          }
        }

        if (usageInput) {
          if (usageRaw) {
            usageInput.value = usageRaw;
            usageInput.disabled = false;
          } else {
            usageInput.disabled = true;
          }
        }
      }

      if (!startRaw) return;

      const start = new Date(startRaw);
      if (isNaN(start.getTime())) return;

      const fmt = (d) => d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' });

      if (recommendedDatesEl) {
        if (mode === 'one-way' || !endRaw) {
          const arrow = '\u2192';
          recommendedDatesEl.textContent = `${fmt(start)} ${arrow} One Way`;
        } else {
          const end = new Date(endRaw);
          if (!isNaN(end.getTime())) {
            const arrow = '\u2192';
            recommendedDatesEl.textContent = `${fmt(start)} ${arrow} ${fmt(end)}`;
          }
        }
      }
    }

    function updateResultColumnsByProductCardHeight() {
      const cards = document.querySelectorAll('article.plan-filter__product-card');
      cards.forEach((card) => {
        const resultContainer = card.closest('.plan-filter__result');
        if (!resultContainer) return;

        const exceedsMaxHeight = card.scrollHeight > card.clientHeight + 10;
        resultContainer.classList.toggle('plan-filter__result--height-capped', exceedsMaxHeight);
      });
    }

    document.querySelectorAll('.plan-filter__plan-details').forEach((el) => {
      initVariantSelector(el);
      initSimToggle(el);
    });

    document.querySelectorAll('article.plan-filter__product-card, article.pf-card-v2').forEach((article) => {
      initAddedToCartObserver(article);
      initQuantityPriceSync(article);
    });

    initTripContext();
    updateResultColumnsByProductCardHeight();

    window.addEventListener('resize', updateResultColumnsByProductCardHeight);
    //window.addEventListener('load', updateResultColumnsByProductCardHeight);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => updateResultColumnsByProductCardHeight());
      document.querySelectorAll('article.plan-filter__product-card').forEach((card) => observer.observe(card));
    }

    // Sticky footer: shown when both plan-filter-calendar and plan-filter__product-card are outside the viewport
    function initStickyFooter() {
      const stickyFooter = document.querySelector('[data-plan-filter-sticky-footer]');

      if (!stickyFooter) return;

      const stickyPriceEl = stickyFooter.querySelector('[data-sticky-price]');
      const stickyCompareEl = stickyFooter.querySelector('[data-sticky-compare-price]');
      const stickyBtn = stickyFooter.querySelector('[data-sticky-add-to-cart]');
      const stickyDecBtn = stickyFooter.querySelector('[data-sticky-quantity-decrease]');
      const stickyIncBtn = stickyFooter.querySelector('[data-sticky-quantity-increase]');
      const stickyQtyDisplay = stickyFooter.querySelector('[data-sticky-quantity-display]');

      const stickyErrorEl = stickyFooter.querySelector('[data-sticky-error]');
      const stickyErrorText = stickyFooter.querySelector('[data-sticky-error-text]');

      const mainContainer = document.querySelector('.plan-filter_product_info');
      const mainSubmitBtn = mainContainer ? mainContainer.querySelector('[type="submit"][name="add"]') : null;
      const mainQtyInput = mainContainer ? mainContainer.querySelector('input[name="quantity"]') : null;
      const mainQtySelector = mainContainer
        ? mainContainer.querySelector('quantity-selector-component[data-plan-quantity-selector]')
        : null;
      const mainErrorEl = mainContainer ? mainContainer.querySelector('[ref="addToCartTextError"]') : null;
      const stickyMaxMessageEl = stickyFooter.querySelector('[data-sticky-max-message]');
      const stickyMaxMessageTextEl = stickyFooter.querySelector('[data-sticky-max-message-text]');
      const formComponent = mainContainer ? mainContainer.querySelector('product-form-component') : null;

      function setVisible(visible) {
        stickyFooter.classList.toggle('is-visible', visible);
        stickyFooter.setAttribute('aria-hidden', String(!visible));
      }

      // Sync price from main card to sticky footer
      function syncPrice() {
        if (!mainContainer) return;
        const mainPriceEl = mainContainer.querySelector('.plan-filter__price');
        const mainCompareEl = mainContainer.querySelector('.plan-filter__price-note');

        if (stickyPriceEl && mainPriceEl) {
          stickyPriceEl.textContent = mainPriceEl.textContent;
        }
        if (stickyCompareEl && mainCompareEl) {
          stickyCompareEl.textContent = mainCompareEl.textContent;
          stickyCompareEl.hidden = mainCompareEl.hidden;
        }
      }

      // Sync disabled + data-added state from main submit button to sticky button
      function syncButtonState() {
        if (!stickyBtn || !mainSubmitBtn) return;
        const isDisabled = mainSubmitBtn.disabled || mainSubmitBtn.classList.contains('is-disabled');
        stickyBtn.disabled = isDisabled;
        stickyBtn.classList.toggle('is-disabled', isDisabled);

        const isAdded = mainSubmitBtn.dataset.added === 'true';
        stickyBtn.dataset.added = String(isAdded);

        const textEl = stickyBtn.querySelector('.add-to-cart-text__content span span');
        const iconEl = stickyBtn.querySelector('.add-to-cart-icon');
        const mainTextEl = mainSubmitBtn.querySelector('.add-to-cart-text__content span span');
        const mainIconEl = mainSubmitBtn.querySelector('.add-to-cart-icon');

        if (textEl && mainTextEl) textEl.textContent = mainTextEl.textContent;
        if (iconEl && mainIconEl) iconEl.innerHTML = mainIconEl.innerHTML;
      }

      // Read constraints from main quantity input attributes
      function getQtyConstraints() {
        const min = parseInt(mainQtyInput?.min || '1', 10) || 1;
        const maxFromData = parseInt(mainQtyInput?.dataset.max || '', 10);
        const maxFromAttribute = parseInt(mainQtyInput?.max || '', 10);
        const max = Number.isFinite(maxFromData)
          ? maxFromData
          : Number.isFinite(maxFromAttribute)
          ? maxFromAttribute
          : Infinity;
        return { min, max };
      }

      // Write new quantity to main form input and update sticky display + button states
      function setStickyQuantity(value) {
        if (!mainQtyInput || !stickyQtyDisplay) return;
        const { min, max } = getQtyConstraints();
        const clamped = Math.min(Math.max(value, min), max);
        mainQtyInput.value = String(clamped);
        if (mainQtySelector) {
          mainQtySelector.dispatchEvent(
            new CustomEvent('quantity-selector:update', {
              bubbles: true,
              detail: { quantity: clamped },
            })
          );
        }
        stickyQtyDisplay.textContent = String(clamped);
        if (stickyDecBtn) stickyDecBtn.disabled = clamped <= min;
        if (stickyIncBtn) stickyIncBtn.disabled = Number.isFinite(max) && clamped >= max;
        if (Number.isFinite(max) && clamped >= max && value >= max) {
          const template = formComponent?.dataset.quantityErrorMax || '';
          const showMaxMessage = (el, textEl) => {
            if (!el) return;
            if (template && textEl) {
              textEl.textContent = 'A maximum of 2 plans are allowed for this plan.';
            }
            el.classList.add('is-visible');
            clearTimeout(el._hideTimer);
            el._hideTimer = setTimeout(() => {
              el.classList.remove('is-visible');
            }, 4000);
          };
          showMaxMessage(stickyMaxMessageEl, stickyMaxMessageTextEl);
        }
      }

      // Mirror quantity from main form to sticky display (e.g. after main form resets on success)
      function syncQuantityFromMain() {
        if (!mainQtyInput || !stickyQtyDisplay) return;
        const val = parseInt(mainQtyInput.value, 10) || 1;
        const { min, max } = getQtyConstraints();
        stickyQtyDisplay.textContent = String(val);
        if (stickyDecBtn) stickyDecBtn.disabled = val <= min;
        if (stickyIncBtn) stickyIncBtn.disabled = Number.isFinite(max) && val >= max;
      }

      // Mirror main error visibility and text to sticky footer error element
      function syncError() {
        if (!mainErrorEl || !stickyErrorEl || !stickyErrorText) return;
        const isHidden = mainErrorEl.classList.contains('hidden');
        stickyErrorEl.classList.toggle('hidden', isHidden);
        // product-form.js writes error text as childNodes[2] of the error element
        const mainTextNode = mainErrorEl.childNodes[2];
        stickyErrorText.textContent = mainTextNode ? mainTextNode.textContent || '' : '';
      }

      if (stickyDecBtn) {
        stickyDecBtn.addEventListener('click', () => {
          const current = parseInt(String(stickyQtyDisplay?.textContent || '1'), 10) || 1;
          setStickyQuantity(current - 1);
        });
      }

      if (stickyIncBtn) {
        stickyIncBtn.addEventListener('click', () => {
          const current = parseInt(String(stickyQtyDisplay?.textContent || '1'), 10) || 1;
          setStickyQuantity(current + 1);
        });
      }

      if (stickyBtn) {
        stickyBtn.addEventListener('click', (event) => {
          if (stickyBtn.disabled) return;
          event.preventDefault();
          if (mainSubmitBtn) {
            mainSubmitBtn.click();
          }
        });
      }

      const stickyBtnContainer = stickyFooter.querySelector('.plan-filter__sticky-footer-actions');
      if (stickyBtnContainer) {
        stickyBtnContainer.addEventListener('click', (event) => {
          if (
            event.target.closest('[data-sticky-quantity-decrease]') ||
            event.target.closest('[data-sticky-quantity-increase]') ||
            event.target.closest('[data-sticky-quantity-display]')
          ) {
            return;
          }
          if (!stickyBtn?.disabled) return;
          const detailsEl = document.querySelector('.plan-filter__plan-details');
          if (detailsEl) showSimTypeError(detailsEl);
        });
      }

      // Direct observer on submit button: most reliable way to catch disabled/class/data-added changes
      if (mainSubmitBtn) {
        new MutationObserver(syncButtonState).observe(mainSubmitBtn, {
          attributes: true,
          attributeFilter: ['disabled', 'class', 'data-added'],
        });
      }

      // Observe main card for price, button state, and quantity changes
      const mainStateSource = mainContainer?.querySelector('.plan-filter__plan-details');

      if (mainStateSource) {
        const cardObserver = new MutationObserver(() => {
          syncPrice();
          syncButtonState();
          syncQuantityFromMain();
        });
        cardObserver.observe(mainStateSource, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['data-added', 'disabled', 'hidden', 'value'],
        });
      }

      // Dedicated observer on main error element: catches class toggle + text node changes
      if (mainErrorEl) {
        const errorObserver = new MutationObserver(syncError);
        errorObserver.observe(mainErrorEl, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
          characterData: true,
          subtree: true,
        });
      }

      const productContainer = document.querySelector('.plan-filter__product-container');
      const productFooter = document.querySelector('.plan-filter__product-footer');

      function isBottomInViewport(el) {
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return rect.bottom >= 0 && rect.bottom <= window.innerHeight;
      }

      function isElementInViewport(el) {
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      }

      function shouldShowStickyFooter() {
  if (!productContainer) return false;
  const productCard = productContainer.querySelector('.plan-filter__product-card');
  if (!productCard) return false;
  if (!productFooter) return false;
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
  const cardRect = productCard.getBoundingClientRect();
  const footerRect = productFooter.getBoundingClientRect();
  const viewportBottomBelowCard = cardRect.bottom <= viewportHeight;
  // Hide only when the whole footer height is within the viewport
  const footerFullyInViewport = footerRect.top >= 0 && footerRect.bottom <= viewportHeight;
  // Visible when viewport is between card bottom and footer area
  const footerNotAboveViewport = footerRect.bottom > 0;
  return viewportBottomBelowCard && footerNotAboveViewport && !footerFullyInViewport;
}

      function updateStickyVisibility() {
        setVisible(shouldShowStickyFooter());
      }

      // Keep visibility check in sync with exact viewport position.
      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility, { passive: true });

      syncPrice();
      syncButtonState();
      syncQuantityFromMain();
      updateStickyVisibility();
    }

    initStickyFooter();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    class TabsBlock extends HTMLElement {
    connectedCallback() {
      const panels = Array.from(this.querySelectorAll(':scope > tab-panel'));
      if (panels.length === 0) return;

      // Create header with buttons
      const header = document.createElement('div');
      header.className = 'tabs__header';
      header.setAttribute('role', 'tablist');

      panels.forEach(function (panel, index) {
        var label = panel.getAttribute('data-label') || 'Tab ' + (index + 1);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tabs__button' + (index === 0 ? ' tabs__button--active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        btn.setAttribute('data-tab-target', panel.getAttribute('data-tab-panel'));
        btn.textContent = label;
        header.appendChild(btn);

        if (index !== 0) {
          panel.hidden = true;
        }
      });

      this.insertBefore(header, this.firstChild);

      var self = this;
      header.querySelectorAll('.tabs__button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetId = btn.getAttribute('data-tab-target');

          header.querySelectorAll('.tabs__button').forEach(function (b) {
            b.classList.remove('tabs__button--active');
            b.setAttribute('aria-selected', 'false');
          });

          panels.forEach(function (p) {
            p.hidden = true;
          });

          btn.classList.add('tabs__button--active');
          btn.setAttribute('aria-selected', 'true');

          var targetPanel = self.querySelector('[data-tab-panel="' + targetId + '"]');
          if (targetPanel) {
            targetPanel.hidden = false;
          }
        });
      });
    }
  }

  if (!customElements.get('tabs-block')) {
    customElements.define('tabs-block', TabsBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["timeline"] && !Shopify.designMode) return;
  try {
    class TimelineBlock extends HTMLElement {
    #scrollAnimation = null;

    connectedCallback() {
      this.viewport = this.querySelector('[ref="viewport"]');
      this.list = this.querySelector('[ref="list"]');
      this.prevButton = this.querySelector('[data-action="prev"]');
      this.nextButton = this.querySelector('[data-action="next"]');

      if (!this.viewport || !this.list || !this.prevButton || !this.nextButton) return;

      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };

      this.prevButton.addEventListener('click', () => this.scrollByStep(-1), options);
      this.nextButton.addEventListener('click', () => this.scrollByStep(1), options);
      this.viewport.addEventListener('scroll', () => this.updateButtons(), { ...options, passive: true });
      this.viewport.addEventListener('keydown', (event) => this.handleKeydown(event), options);

      this.resizeObserver = new ResizeObserver(() => this.updateButtons());
      this.resizeObserver.observe(this.viewport);

      this.updateButtons();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      if (this.#scrollAnimation) cancelAnimationFrame(this.#scrollAnimation);
    }

    handleKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.scrollByStep(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.scrollByStep(1);
      }
    }

    scrollByStep(direction) {
      const firstItem = this.list.querySelector('.timeline-item');
      if (!firstItem) return;

      const listStyles = window.getComputedStyle(this.list);
      const gap = Number.parseFloat(listStyles.columnGap || listStyles.gap || '0') || 0;
      const step = firstItem.getBoundingClientRect().width + gap;

      this.#animateScroll(direction * step);
    }

    #animateScroll(delta) {
      if (this.#scrollAnimation) cancelAnimationFrame(this.#scrollAnimation);

      const duration = 480;
      const start = this.viewport.scrollLeft;
      const target = Math.max(0, Math.min(start + delta, this.viewport.scrollWidth - this.viewport.clientWidth));
      const startTime = performance.now();

      const easeInOutCubic = (t) => (t < 0.5 ? 12 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 8) / 2);

      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        this.viewport.scrollLeft = start + (target - start) * easeInOutCubic(progress);

        if (progress < 1) {
          this.#scrollAnimation = requestAnimationFrame(step);
        } else {
          this.#scrollAnimation = null;
        }
      };

      this.#scrollAnimation = requestAnimationFrame(step);
    }

    updateButtons() {
      const maxScrollLeft = this.viewport.scrollWidth - this.viewport.clientWidth;
      const currentScroll = this.viewport.scrollLeft;
      const threshold = 2;

      this.prevButton.disabled = currentScroll <= threshold;
      this.nextButton.disabled = currentScroll >= maxScrollLeft - threshold;
    }
  }

  if (!customElements.get('timeline-block')) {
    customElements.define('timeline-block', TimelineBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
